import { FormattedMessage } from 'react-intl';

export type ServiceInfoDialogMenuItemProps = {
    chapter: string;
    activeChapter: string;
    onClick: () => void;
    trackingLabel: string;
};

export const ServiceInfoDialogMenuItem = ({ chapter, activeChapter, onClick }: ServiceInfoDialogMenuItemProps) => (
    // biome-ignore lint/a11y/noStaticElementInteractions: <span> used as a button
    <span className={activeChapter === chapter ? 'active' : undefined} data-name={chapter} onClick={onClick}>
        <FormattedMessage id={`intl-msg:rental-web.serviceinfo.${chapter}`} />
    </span>
);
